module.exports = __webpack_public_path__ + "static/media/icon-wire.04d91a0b.svg";